export class GlobalConstants
{
    public static readonly USER_HEADING_INFORMATION = "user.heading.information";
    public static readonly USER_ORGANIZATION_INFORMATION = "user.organization.information";
}